import NiceModal from '@ebay/nice-modal-react';
import dayjs from 'dayjs';
import { makeAutoObservable, when } from 'mobx';

import * as fbApi from '@/api/fb';
import { getSubscribeData } from '@/api/game';
import { getVipKefuFlag, setVipKefuFlag } from '@/api/hall';
import { getAvgpay, getDailyPackage, getJieti, getJietiConfig, getPayconfig, getPochan } from '@/api/recharge';
import * as continueRechargeApi from '@/api/recharge/continue-recharge';
import showNiceModal from '@/components/nice-modal';
import { ACCESS_USERID_KEY } from '@/constant/config';
import { DOLE_NUM } from '@/constant/config';
import { IpaTaskModal } from '@/modules/ipa-task';
import Jackpot from '@/modules/jackpot';
import AndroidPwaSofe from '@/modules/modal/AndroidPwaSofe';
import BindPhoneModal from '@/modules/modal/BindPhoneModal';
import ContinueRechargeModal from '@/modules/modal/ContinueRecharge/ContinueRecharge';
import DailyModal from '@/modules/modal/DailyModal';
import DailyPackageModal from '@/modules/modal/DailyPackageModal';
import DoleModal from '@/modules/modal/DoleModal';
import DownloadModal from '@/modules/modal/DownloadModal';
import showFbBindModal from '@/modules/modal/FbBind';
import FirstRechargeModal from '@/modules/modal/FirstRecharge';
import { FishInModal, FishOutModal } from '@/modules/modal/FishInOutModal';
import HintListModal from '@/modules/modal/HintListModal';
import HintModal from '@/modules/modal/HintModal';
import IosPwaModal from '@/modules/modal/IosPwaModal';
import JietiModal from '@/modules/modal/JietiModal';
import KefuModal from '@/modules/modal/KefuModal';
import GetCDKModal from '@/modules/modal/modal-get-cdk';
import NiceShouChongModal from '@/modules/modal/nice-shouchong';
import NotLoginWelcomeModal from '@/modules/modal/NotLoginWelcomeModal';
import OpenBrowser from '@/modules/modal/OpenBrowser';
import PochanHorizontalModal from '@/modules/modal/PochanHorizontalModal';
import PochanModal from '@/modules/modal/PochanModal';
import PwaModal from '@/modules/modal/PwaModal';
import PwaSafeModal from '@/modules/modal/PwaSafeModal';
import ReceiveModal from '@/modules/modal/ReceiveModal';
import SubscribelModal from '@/modules/modal/SubscribeModal';
import VipModal from '@/modules/modal/VipModal';
import WelcomeModal from '@/modules/modal/WelcomeModal';
import WhatsappModalActivate from '@/pages/whatsapp/modal/activateV2/activate';
import ModalWheel from '@/pages/whatsapp/modal/wheel';
import { getIsShowFbBind, isInApk } from '@/utils/apk';
import Storage from '@/utils/Storage';
import { getDevice, inPwaEnv, isInChromeBrowser, isPwaSource } from '@/utils/utils';

import { gameStore } from './game';
import rechargeStore from './recharge';
import globalStore from './store';

type modalOpenType =
  | ''
  | 'firstRecharge'
  | 'advertise'
  | 'pochan'
  | 'jieti'
  | 'daily'
  | 'welcome'
  | 'download'
  | 'not-login-welcome'
  | 'open-browser'
  | 'ios-pwa'
  | 'android-pwa-safe'
  | 'pwa-modal'
  | 'pwa-safe-modal'
  | 'receive'
  | 'daily-package'
  | 'vip'
  | 'subscription'
  | 'pochan-horizontal'
  | 'dole'
  | 'firstRechargeNew';

export const modalStore = makeAutoObservable({
  // 弹窗容器显示隐藏
  modalVisible: true,

  /**
   * 是否任务链
   */
  isTaskChain: false,

  /**
   * 是否任务链结束
   */
  isTaskChainFinish: false,

  /**
   * 弹窗展示
   * type  firstRecharge 首冲 advertise 广告弹窗 pochan 破产  jieti 阶梯   daily 每日签到 a 升级到vip vip
   */
  modalOpen: '',

  /**
   * 是否展示破产banner
   */
  isShowPochanBanner: false,

  /**
   * 是否展示阶梯banner
   */
  isShowJietiBanner: false,

  /**
   * 是否展示每日礼包
   */
  isShowDailyPackage: false,

  // 所有破产礼包
  pochanConfigs: [] as API.pochanResponse['record'],
  pochanConfigList: [] as API.pochanResponse['record'],
  avgpay: 0,

  // 首冲
  firstRechargeConfig: [] as API.FirstRechargeResponse['record'],

  // 广告
  advertiseConfig: {} as any,

  // 破产
  pochanConfig: [] as API.pochanResponse['record'],

  // 每日礼包
  dailyPackageConfig: [] as API.DailyPackageResponse['record'],
  dailyPackageBuyCount: 0,
  dailyPackageAwardmoney: 0,

  // 阶梯显示
  jietiConfig: {} as any,
  jietiConfigs: [] as any,
  curentJieti: {} as any,

  // 每日签到
  dailyConfig: {} as any,

  setModalVisible(modalVisible) {
    this.modalVisible = modalVisible;
  },

  setOpenBrowser() {
    showNiceModal(
      {
        width: '6.5rem',
        maskClosable: true,
        contentStyle: {
          background: 'rgba(0, 0, 0, 0)'
        },
        closable: {
          hideClose: true
        },
        render: OpenBrowser
      },
      'open-browser-modal'
    );
    // this.modalOpen = 'open-browser';
  },

  // 打开未登录欢迎弹窗
  openNotLoginWelcome() {
    showNiceModal(
      {
        width: '6rem',
        maskClosable: true,
        contentStyle: {
          background: 'rgba(0, 0, 0, 0)'
        },
        render: NotLoginWelcomeModal
      },
      'not-login-welcome-modal'
    );
    // this.modalOpen = 'not-login-welcome';
  },

  // 打开下载弹窗
  openDownload() {
    showNiceModal(
      {
        width: '6.5rem',
        maskClosable: true,
        contentStyle: {
          background: 'rgba(0, 0, 0, 0)'
        },
        render: DownloadModal
      },
      'download-modal'
    );
    // this.modalOpen = 'download';
  },

  async openFbBind() {
    const viplevel = globalStore?.initialState?.viplevel;

    if (!isInApk() || viplevel > 0 || !getIsShowFbBind()) {
      return;
    }

    // 次日开始
    const { registerdate } = globalStore.userInfo;
    const nextDay = dayjs(registerdate).add(1, 'day').startOf('day');
    if (dayjs().isBefore(nextDay)) {
      return;
    }

    const data = await fbApi.getFbBindInfo();
    if (data.has_bind !== 0) return;
    const modal = await showFbBindModal({ chaining: true, top: '15vh', innerProps: { data } });
    modal.closeWithTransition?.();
  },

  // 获取破产礼包
  async queryPochanConfig() {
    if (this.pochanConfigs?.length) return this.pochanConfigs;

    const data = await getPayconfig(3);
    this.pochanConfigs = data?.record || [];
    return data.record;
  },

  // 打开首冲弹窗
  async openFirstRecharge() {
    if (this.firstRechargeConfig.length === 0) {
      const data = await getPayconfig(1);
      this.firstRechargeConfig = data?.record || [];
    }

    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        chaining: true,
        render: NiceShouChongModal
      },
      'first-recharge-modal'
    );
    modal.closeWithTransition?.();
  },

  async refreshFirstRecharge() {
    const data = await getPayconfig(1);
    this.firstRechargeConfig = data?.record || [];
  },

  async openAdvertise() {
    this.modalOpen = 'advertise';
  },

  async queryPochan() {
    const score = globalStore?.initialState?.score;
    const viplevel = globalStore?.initialState?.viplevel;
    if (viplevel === 0 || score >= 5) {
      this.isShowPochanBanner = false;
      return;
    }

    const data = await getPochan();

    if (!data?.record?.length) return;
    this.pochanConfig = data?.record;

    if (data?.record.length > 0 && score < data?.record[0].last_limit / 100) {
      this.isShowPochanBanner = true;
      return data;
    }
  },

  // 打开破产弹窗
  async openPochan() {
    const score = globalStore?.initialState?.score;
    const data = await this.queryPochan();

    if (!data || data?.record.length === 0 || score > data?.record[0].last_limit / 100) {
      this.isShowPochanBanner = false;
      return false;
    }
    this.isShowPochanBanner = true;
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        chaining: true,
        render: PochanModal
      },
      'pochan-vertical-modal'
    );
    modal.closeWithTransition?.();
  },

  async openHorizontalPochan() {
    const configs = await this.queryPochanConfig();
    const data = await getAvgpay();
    const { record } = data;

    this.avgpay = record[0]?.avgpay ?? 0;

    this.pochanConfigList = configs.filter(item => {
      return this.avgpay >= item.avgpay_begin && this.avgpay <= item.avgpay_end;
    });

    if (this.pochanConfigList.length === 0) {
      // 取前三个， 不影响原数组
      this.pochanConfigList = configs.slice(0, 3);
    }
    const modal = await showNiceModal(
      {
        maskClosable: true,
        closable: {
          hideClose: true
        },
        width: '7.5rem',
        top: '0',
        contentStyle: {
          position: 'relative',
          height: '100vh',
          background: '#ffffff00'
        },
        chaining: true,
        render: PochanHorizontalModal
      },
      'pochan-horizontal-modal'
    );
    modal.closeWithTransition?.();
  },

  async refreshPochan() {
    const data = await getPochan();

    if (!data?.record?.length) {
      modalStore.closeModal();
      return;
    }
    this.pochanConfig = data?.record;
  },

  // 阶梯礼包查询
  async queryJieti() {
    const viplevel = globalStore?.initialState?.viplevel;

    if (viplevel === 0) {
      this.isShowJietiBanner = false;
      return;
    }
    const [config, jieti] = await Promise.all([getJietiConfig(), getJieti()]);
    const { payamount_step } = jieti?.record?.[0] ?? {};
    const item = config.record.find(item => item.payfee > payamount_step);

    if (item) {
      this.jietiConfig = item;
      this.isShowJietiBanner = true;
    }
  },

  // 打开阶梯弹窗
  async openJieti() {
    const viplevel = globalStore?.initialState?.viplevel;
    const data = await getJietiConfig();

    this.jietiConfigs = [data.giftitem];
    if (viplevel === 0) {
      this.isShowJietiBanner = false;
      return;
    }
    const modal = await showNiceModal(
      {
        width: '6.6rem',
        maskClosable: true,
        chaining: true,
        render: JietiModal
      },
      'jieti-modal'
    );
    modal.closeWithTransition?.();
    // this.modalOpen = 'jieti';
  },

  async refreshJieti() {
    const data = await getJietiConfig();
    this.jietiConfigs = [data.giftitem];
  },

  // 设置每日签到弹窗数据
  setDailyConfig(take_info, config, config_status) {
    const status = ['disabled', 'received', '', 'expired'];
    const { next_take_timer, is_need_pay } = take_info;

    this.dailyConfig = {
      take_info,
      next_take_timer,
      is_need_pay,
      config: config.map((amount, i) => ({
        status: status[config_status[i]],
        amount: amount
      }))
    };
  },

  // 每日礼包数据获取
  async getDailyPackage() {
    const data = await getDailyPackage();
    this.dailyPackageConfig = data.record;
    this.dailyPackageBuyCount = data.hasBuyCount;
    this.dailyPackageAwardmoney = data.awardmoney;
    this.isShowDailyPackage = data.takeRewardForAllBuy < 2;

    return data;
  },

  async openDailyPackage() {
    const data = await this.getDailyPackage();

    // 已领取
    if (data.takeRewardForAllBuy === 2) return;

    // this.modalOpen = 'daily-package';
    const modal = await showNiceModal({
      maskClosable: true,
      width: '6.6rem',
      chaining: true,
      render: DailyPackageModal
    });
    modal.closeWithTransition?.();
  },

  async refreshDailyPackage() {
    const data = await getDailyPackage();
    this.dailyPackageConfig = data.record;
    this.dailyPackageBuyCount = data.hasBuyCount;
    this.dailyPackageAwardmoney = data.awardmoney;
    this.isShowDailyPackage = data.takeRewardForAllBuy < 2;
    if (data.takeRewardForAllBuy === 2) {
      this.closeModal();
    }
  },

  // 打开每日签到弹窗
  async openDaily(
    innerProps: any = {
      from: 'chain'
    }
  ) {
    // const data = await query_user_daygold_v2();
    // const { take_info, config, config_status } = data;
    if (innerProps?.from === 'chain' && this.dailyConfig?.take_info?.is_take_today === 1) return;
    // this.setDailyConfig(take_info, config, config_status);
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        chaining: true,
        contentStyle: {
          background: '#ffffff00'
        },
        render: (modal, onClose, innerProps) => <DailyModal {...innerProps} />,
        innerProps: innerProps
      },
      'daily-modal'
    );
    modal.closeWithTransition?.();
  },

  async querySubscribeData() {
    const hasSubscribe = getSubscriptionInfo();

    if (hasSubscribe) return;

    const machineserial = await getUniqueID();
    const userid = Storage.getAccess(ACCESS_USERID_KEY);

    const res = await getSubscribeData({
      userid,
      machineserial: machineserial
    });

    if (res.ret === 0 && res.page) {
      const channel = getAPKCHSource().toLocaleUpperCase().replace('CH_', '');
      const type = isInApk() ? 0 : 1;
      const url = `${
        res.page
      }?machineserial=${machineserial}&userid=${userid}&channel=${channel}&type=${type}&returnurl=${encodeURIComponent(
        location.href
      )}`;

      Storage.set('subscribe_page', url);

      await this.openSubscriptionModal();
    }
  },

  async openWelcome() {
    const modal = await showNiceModal(
      {
        maskClosable: false,
        closable: {
          hideClose: true
        },
        top: '0.5rem',
        width: '7.17rem',
        chaining: true,
        contentStyle: {
          background: '#ffffff00'
        },
        render: WelcomeModal
      },
      'welcome-modal'
    );
    modal?.onClose();
    await this.openReceive();
  },
  // 打开jackpot
  async openJackpot() {
    const modal = await showNiceModal({
      width: '6.62rem',
      top: '0.91rem',
      contentStyle: {
        background: 'transparent'
      },
      maskClosable: true,
      render: Jackpot
    });
    modal.closeWithTransition?.();
  },

  // 打开订阅弹窗
  async openSubscriptionModal() {
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        top: '30vh',
        chaining: true,
        render: SubscribelModal
      },
      'subscribe-modal'
    );
    modal.closeWithTransition?.();
  },
  /** 打开连续充值弹窗 */
  async openContinueRecharge() {
    // debugger
    if (this.isShowPochanBanner) return;
    const res = await continueRechargeApi.getContinueRecharge();
    if ((res?.record || []).some(item => !!item.paytime)) return;
    const modal = await showNiceModal(
      {
        children: <ContinueRechargeModal />,
        width: '6rem',
        top: '15vh',
        chaining: true,
        maskClosable: true
      },
      'continue-recharge-modal'
    );
    modal.closeWithTransition?.();
  },

  closeTaskChain() {
    this.modalOpen = '';
    this.isTaskChain = false;
    this.isTaskChainFinish = true;
  },

  closeModal(name = 'my-nice-modal') {
    this.modalOpen = '';
    NiceModal.remove(name);
  },

  openBindPhone(innerProps: any = {}) {
    showNiceModal(
      {
        width: '6.5rem',
        maskClosable: true,
        innerProps,
        render: BindPhoneModal
      },
      'bind-phone-modal'
    );
  },

  openIosPwa() {
    // this.modalOpen = 'ios-pwa';
    const isChrome = isInChromeBrowser();
    showNiceModal(
      {
        width: '7.5rem',
        closable: {
          hideClose: true
        },
        contentStyle: {
          background: 'transparent'
        },
        top: isChrome ? '-0.6rem' : 'unset',
        bottom: isChrome ? 'unset' : '0',
        maskClosable: true,
        render: IosPwaModal
      },
      'ios-pwa-modal'
    );
  },

  async openIpaModal() {
    const modal = await showNiceModal(
      {
        chaining: true,
        contentStyle: {
          background: 'transparent',
          overflow: 'unset'
        },
        width: '6.72rem',
        maskClosable: true,
        render: IpaTaskModal
      },
      'ipa-modal'
    );
    modal?.onClose?.();
    modal.closeWithTransition?.();
  },

  openAndroidPwaSafe() {
    showNiceModal(
      {
        closable: {
          hideClose: true
        },
        width: '6.5rem',
        maskClosable: true,
        render: AndroidPwaSofe
      },
      'android-pwa-sofe-modal'
    );
  },

  async openPwaModal(innerProps: any = {}) {
    const modal = await showNiceModal(
      {
        chaining: true,
        contentStyle: {
          background: '#ffffff00'
        },
        width: '6.5rem',
        innerProps,
        maskClosable: true,
        render: PwaModal
      },
      'pwa-modal'
    );
    modal.closeWithTransition?.();
  },

  openPwaSafeModal() {
    showNiceModal(
      {
        closable: {
          hideClose: true
        },
        width: '6rem',
        maskClosable: true,
        render: PwaSafeModal
      },
      'pwa-safe-modal'
    );
  },

  async openReceive() {
    const modal = await showNiceModal(
      {
        maskClosable: false,
        closable: {
          hideClose: true
        },
        width: '6rem',
        chaining: true,
        contentStyle: {
          background: '#ffffff00'
        },
        render: ReceiveModal
      },
      'receive-modal'
    );
    modal?.onClose();
  },

  async openFishInModal(innerProps: any = {}) {
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6rem',
        chaining: true,
        contentStyle: {
          background: '#2E3541'
        },
        innerProps,
        render: FishInModal
      },
      'fish-in-modal'
    );
    modal?.onClose?.();
    modal.closeWithTransition?.();
  },

  async openFishOutModal(innerProps: any = {}) {
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6rem',
        chaining: true,
        contentStyle: {
          background: '#2E3541'
        },
        innerProps,
        render: FishOutModal
      },
      'fish-out-modal'
    );
    modal?.onClose?.();
    modal.closeWithTransition?.();
  },

  /** 救济金 */
  async openDole() {
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6rem',
        chaining: true,
        contentStyle: {
          background: '#ffffff00'
        },
        render: DoleModal
      },
      'dole-modal'
    );
    modal.closeWithTransition?.();
  },
  /** vip */
  openVip() {
    showNiceModal(
      {
        width: '6.5rem',
        maskClosable: true,
        contentStyle: {
          background: 'rgba(0, 0, 0, 0)'
        },
        render: VipModal
      },
      'vip-modal'
    );
  },

  closeShowDailyPackage() {
    this.isShowDailyPackage = false;
  },

  async openFirstRechargeModal() {
    const leftTime = rechargeStore?.firstRecharge?.leftTime;
    const vippoint = globalStore?.initialState?.vippoint;

    if (vippoint > 0 || leftTime <= 0) return;
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        children: <FirstRechargeModal />,
        contentStyle: {
          borderRadius: '0.1rem'
        },
        chaining: true
      },
      'firstRechargeModal'
    );
    modal.closeWithTransition?.();
  },

  async openWhatsappActivate(closable = true) {
    const modal = await showNiceModal(
      {
        width: '7.5rem',
        maskClosable: false,
        closable: {
          hideClose: true
        },
        chaining: true,
        contentStyle: {
          background: 'rgba(0, 0, 0, 0)'
        },
        innerProps: { closable },
        render: ModalWheel
      },
      'whatsapp-modal'
    );
    if (modal?.prize) {
      modal?.onClose();
      await globalStore.fetchBalance();
      // NiceModal.remove('whatsapp-modal');
      await this.openWhatsappScore(true);
    } else {
      modal?.onClose();
      modal.closeWithTransition?.();
    }
  },

  async openWhatsappScore(animate = false) {
    const whatsapp_lb = globalStore?.initialState?.whatsapp_lb || {};
    const modal = await showNiceModal(
      {
        width: '6.6rem',
        contentStyle: {
          background: 'transparent',
          overflow: 'unset'
        },
        chaining: true,
        innerProps: {
          ...whatsapp_lb,
          animate
        },
        maskClosable: true,
        render: WhatsappModalActivate
      },
      'lottery-modal'
    );
    modal?.onClose?.();
    modal.closeWithTransition?.();
  },

  openGetCdk() {
    showNiceModal(
      {
        maskClosable: true,
        width: '6.6rem',
        render: GetCDKModal
      },
      'getcdk-modal'
    );
  },

  openRejectLogin(err) {
    showNiceModal({
      top: '2rem',
      maskClosable: false,
      closable: {
        closeIcon: <></>
      },
      contentStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.4rem',
        minHeight: '2.4rem'
      },
      children: <div>{err || 'error'}</div>
    });
  },

  async openKefu() {
    const modal = await showNiceModal(
      {
        maskClosable: true,
        width: '6rem',
        top: '2rem',
        chaining: true,
        contentStyle: {
          background: 'transparent'
        },
        render: KefuModal
      },
      'kefu-modal'
    );

    modal.closeWithTransition?.();
  },

  openHintModal(content = '', cb: Function = () => {}) {
    showNiceModal(
      {
        top: '2rem',
        width: '5.6rem',
        closable: {
          hideClose: true
        },
        render: HintModal,
        innerProps: {
          content,
          cb
        }
      },
      'hint_modal'
    );
  },

  openHintListModal(contents = [''], cb: Function = () => {}) {
    showNiceModal(
      {
        top: '15vh',
        width: '6rem',
        maskClosable: true,
        closable: {
          hideClose: true
        },
        render: HintListModal,
        innerProps: {
          contents,
          cb
        }
      },
      'hint-list-modal'
    );
  },

  /** 开启任务链  游客首次登录进入首页
   * 新人弹窗
   * 诱导弹窗
   */
  //----------------------------------------------
  enableVisitorTaskChain() {
    const list: any[] = [];
    list.push({ key: 'welcome', handle: 'openWelcome' });
    if (!globalStore?.resetflag) {
      list.push({ key: 'whatsapp-wheel', handle: 'openWhatsappActivate' });
    } else {
      list.push({ key: 'whatsapp-activate', handle: 'openWhatsappScore' });
    }
    if (globalStore?.initialState?.viplevel === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    }
    if (isPwaSource() && !inPwaEnv() && !isInApk() && !SingletonPrompt.getInstance().getInstalled()) {
      list.push({ key: 'pwa-modal', handle: 'openPwaModal' });
    }
    this.isTaskChain = true;
    generatorModal(list);
  },

  /** 开启任务链  手机号注册首次登录进入首页
   * 新人弹窗
   * 诱导弹窗
   */
  //----------------------------------------------
  enableNewUserTaskChain() {
    const list: any[] = [];
    list.push({ key: 'welcome', handle: 'openWelcome' });
    if (!globalStore?.resetflag) {
      list.push({ key: 'whatsapp-wheel', handle: 'openWhatsappActivate' });
    } else {
      list.push({ key: 'whatsapp-activate', handle: 'openWhatsappScore' });
    }
    if (globalStore?.initialState?.viplevel === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    }
    if (isPwaSource() && !inPwaEnv() && !isInApk() && !SingletonPrompt.getInstance().getInstalled()) {
      list.push({ key: 'pwa-modal', handle: 'openPwaModal' });
    }
    this.isTaskChain = true;
    generatorModal(list);
  },

  /** 开启任务链  非新用户每日首次进入首页
   * 每日登录（可领取）
   * WhatsApp待激活：激活弹窗
   * WhatsApp已激活：裂变获得弹窗
   * 限时首充（非VIP）
   * 破产礼包（VIP 用户身金低于设定值）
   * 引导添加桌面（H5非PWA进入）
   */
  //----------------------------------------------
  async enableDayFirstLoginTaskChain() {
    const list: any[] = [];
    const device = getDevice();
    const isIos = device === 'ios';

    list.push({ key: 'fbBind', handle: 'openFbBind' });

    list.push({ key: 'daily', handle: 'openDaily' });

    if (!globalStore?.resetflag) {
      list.push({ key: 'whatsapp-wheel', handle: 'openWhatsappActivate' });
    } else {
      list.push({ key: 'whatsapp-activate', handle: 'openWhatsappScore' });
    }

    if (globalStore?.initialState?.viplevel === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    } else {
      list.push({ key: 'pochan', handle: 'openPochan' });
    }

    if (isPwaSource() && !inPwaEnv() && !isInApk() && !SingletonPrompt.getInstance().getInstalled()) {
      isIos
        ? list.unshift({ key: 'pwa-modal', handle: 'openPwaModal' })
        : list.push({ key: 'pwa-modal', handle: 'openPwaModal' });
    }
    if (
      globalStore?.initialState?.viplevel > 0 &&
      globalStore?.userInfo?.ios_super !== 1 &&
      window?.privateConfig?.code === 'ipa'
    ) {
      list.push({ key: 'ipa-modal', handle: 'openIpaModal' });
    }

    const userId = Storage.getAccess(ACCESS_USERID_KEY);
    const isOpened = Storage.get('IS_KEFU_OEPNED_' + userId, false);
    if (globalStore?.isTestServicer && globalStore?.initialState?.viplevel > 0) {
      const { data: flag } = await getVipKefuFlag();
      if (flag === 0) {
        if (isOpened) {
          setVipKefuFlag();
        } else {
          list.push({ key: 'kefu-modal', handle: 'openKefu' });
        }
      }
    }

    this.isTaskChain = true;
    generatorModal(list);
  },

  /** 开启任务链  非新用户每日非首次进入首页 */
  //----------------------------------------------
  enableDayOtherLoginTaskChain() {
    const list: any[] = [];
    const device = getDevice();
    const isIos = device === 'ios';
    const registerDate = globalStore?.initialState?.registerDate;
    const isToday = dayjs().isSame(dayjs(registerDate), 'day');
    if (
      isPwaSource() &&
      !inPwaEnv() &&
      !isInApk() &&
      !SingletonPrompt.getInstance().getInstalled() &&
      isIos &&
      !isToday
    ) {
      list.push({ key: 'ios-pwa-modal', handle: 'openPwaModal' });
    }

    list.push({ key: 'fbBind', handle: 'openFbBind' });

    if (globalStore?.initialState?.viplevel === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    } else {
      list.push({ key: 'pochan', handle: 'openPochan' });
    }
    if (
      globalStore?.initialState?.viplevel > 0 &&
      globalStore?.userInfo?.ios_super !== 1 &&
      window?.privateConfig?.code === 'ipa'
    ) {
      list.push({ key: 'ipa-modal', handle: 'openIpaModal' });
    }
    this.isTaskChain = true;
    generatorModal(list);
  },
  /** 开启任务链 */
  enableTaskChain() {
    const { showGame } = gameStore;
    if (showGame) {
      return;
    }

    const userid = Storage.getAccess(ACCESS_USERID_KEY);
    const env = getDevice();

    // 是否领取每日签到
    const isReceiveDaily = Storage.get(`daily_modal_click_${userid}_${dayjs().format('YYYYMMDD')}`);

    let list: {
      key: string;
      handle: string;
    }[] = [];
    // 首次登陆
    /* 不使用 const {} = globalStore?.initialState; 原因是层级太深可能更新不及时 */
    if (globalStore?.initialState?.isFirstLogin) {
      list = [
        {
          key: 'welcome',
          handle: 'openWelcome'
        }
      ];
    }
    if (!isReceiveDaily) {
      // if (!isReceiveDaily && score <= 5) {
      list.push({
        key: 'daily',
        handle: 'openDaily'
      });
    }
    // if (!globalStore?.resetflag) {
    //   list.push({
    //     key: 'whatsapp-wheel',
    //     handle: 'openWhatsappActivate'
    //   });
    // } else {
    //   list.push({
    //     key: 'whatsapp-activate',
    //     handle: 'openWhatsappScore'
    //   });
    // }

    if (globalStore?.initialState?.vippoint === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
      // list.push({
      //   key: 'firstRecharge',
      //   handle: 'openFirstRecharge'
      // });
    } else {
      if (globalStore?.initialState?.viplevel > 0) {
        list.push({
          key: 'pochan',
          handle: 'openPochan'
        });
      }
      list.push({
        key: 'continueRecharge',
        handle: 'openContinueRecharge'
      });
    }
    if (
      isPwaSource() &&
      env === 'android' &&
      !inPwaEnv() &&
      !isInApk() &&
      !SingletonPrompt.getInstance().getInstalled() &&
      !globalStore?.initialState?.isFirstLogin
    ) {
      list.push({
        key: 'pwa-modal',
        handle: 'openPwaModal'
      });
    }
    if (
      globalStore?.initialState?.viplevel > 0 &&
      globalStore?.userInfo?.ios_super !== 1 &&
      window?.privateConfig?.code === 'ipa'
    ) {
      list.push({ key: 'ipa-modal', handle: 'openIpaModal' });
    }
    this.isTaskChain = true;
    generatorModal(list);
  },

  /** 退出游戏打开任务链 */
  async enableTaskChainByExitGame() {
    const viplevel = globalStore?.initialState?.viplevel;
    const vippoint = globalStore?.initialState?.vippoint;
    const score = globalStore?.initialState?.score;
    const device = getDevice();
    const isIos = device === 'ios';
    const list: any[] = [];
    if (isPwaSource() && !inPwaEnv() && !isInApk() && !SingletonPrompt.getInstance().getInstalled() && isIos) {
      list.push({ key: 'ios-pwa-modal', handle: 'openPwaModal' });
    }
    // 救济金
    if (score < DOLE_NUM) {
      list.push({
        key: 'dole',
        handle: 'openDole'
      });
    }
    if (!globalStore?.resetflag) {
      list.push({ key: 'whatsapp-wheel', handle: 'openWhatsappActivate' });
    } else {
      list.push({ key: 'whatsapp-activate', handle: 'openWhatsappScore' });
    }
    if (vippoint === 0) {
      // 首充礼包（非VIP用户）
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    } else {
      if (viplevel > 0) {
        // 破产弹窗
        list.push({
          key: 'pochan',
          handle: 'openPochan'
        });
      }
    }
    if (
      globalStore?.initialState?.viplevel > 0 &&
      globalStore?.userInfo?.ios_super !== 1 &&
      window?.privateConfig?.code === 'ipa'
    ) {
      list.push({ key: 'ipa-modal', handle: 'openIpaModal' });
    }
    this.isTaskChain = true;

    generatorModal(list);
  },

  /**
   * 商城页 任务链条
   */
  async openTaskChainInRechargePage() {
    const list: any[] = [];

    if (globalStore?.initialState?.vippoint === 0) {
      list.push({ key: 'firstRechargeNew', handle: 'openFirstRechargeModal' });
    } else {
      if (globalStore?.initialState?.viplevel > 0) {
        // 破产弹窗
        list.push({
          key: 'pochan',
          handle: 'openPochan'
        });
      }
    }

    modalStore.isTaskChain = true;

    generatorModal(list);
  }
});

async function close(key) {
  return new Promise(resolve => {
    when(
      () => modalStore.modalOpen !== key,
      () => {
        if (!modalStore.isTaskChain) {
          return;
        }
        if (!modalStore.modalOpen && modalStore.isTaskChain) {
          resolve(true);
        }
      }
    );
  });
}

async function generatorModal(list) {
  for await (const item of list) {
    const { key, handle } = item;
    await modalStore[handle]();
    await close(key);
  }
  modalStore.closeTaskChain();
  modalStore.isTaskChainFinish = true;
}
